import {
    BROADCAST_LIST_FETCH_ERROR,
    BROADCAST_LIST_FETCH_IN_PROGRESS,
    BROADCAST_LIST_FETCH_SUCCESS,
    DELETE_DESTINATION_FETCH_ERROR,
    DELETE_DESTINATION_FETCH_IN_PROGRESS,
    DELETE_DESTINATION_FETCH_SUCCESS,
    FETCH_YOUTUBE_STATUS_ERROR,
    FETCH_YOUTUBE_STATUS_IN_PROGRESS,
    FETCH_YOUTUBE_STATUS_SUCCESS,
    GO_LIVE_FETCH_ERROR,
    GO_LIVE_FETCH_IN_PROGRESS,
    GO_LIVE_FETCH_SUCCESS,
    HIDE_LIVE_STREAM_DELETE_DIALOG,
    LIVE_STREAM_DESCRIPTION_SET,
    LIVE_STREAM_ID_SET,
    LIVE_STREAM_KEY_SET,
    LIVE_STREAM_SCHEDULE_END_DATE_SET,
    LIVE_STREAM_SCHEDULE_START_DATE_SET,
    LIVE_STREAM_SETUP_DIALOG_HIDE,
    LIVE_STREAM_SETUP_DIALOG_SHOW,
    LIVE_STREAM_SETUP_NAME_SET,
    LIVE_STREAM_SETUP_NODE_SET,
    LIVE_STREAM_THUMBNAIL_SET,
    LIVE_STREAM_VISIBILITY_SET,
    LIVE_VIDEOS_LIST_FETCH_ERROR,
    LIVE_VIDEOS_LIST_FETCH_IN_PROGRESS,
    LIVE_VIDEOS_LIST_FETCH_SUCCESS,
    REMOVE_MEDIA_NODE_FETCH_ERROR,
    REMOVE_MEDIA_NODE_FETCH_IN_PROGRESS,
    REMOVE_MEDIA_NODE_FETCH_SUCCESS,
    REMOVE_MEDIANODE_CONFIRM_DIALOG_HIDE,
    REMOVE_MEDIANODE_CONFIRM_DIALOG_SHOW,
    SCHEDULE_LIVE_SWITCH_SET,
    SELECTED_DESTINATIONS_LIST_SET,
    SET_STREAM_INFO_EMPTY,
    SHOW_LIVE_STREAM_DELETE_DIALOG,
    SYNC_STUDIO_LIVE_STREAM_FETCH_ERROR,
    SYNC_STUDIO_LIVE_STREAM_FETCH_IN_PROGRESS,
    SYNC_STUDIO_LIVE_STREAM_FETCH_SUCCESS,
    TV_LIVE_STREAM_ADD_IN_PROGRESS,
    TV_LIVE_STREAM_ADD_SUCCESS,
    TV_LIVE_STREAM_DELETE_ERROR,
    TV_LIVE_STREAM_DELETE_IN_PROGRESS,
    TV_LIVE_STREAM_DELETE_SUCCESS,
    TV_LIVE_STREAM_FETCH_ERROR,
    TV_LIVE_STREAM_FETCH_IN_PROGRESS,
    TV_LIVE_STREAM_FETCH_SUCCESS,
    TV_LIVE_STREAM_PUBLISH_ERROR,
    TV_LIVE_STREAM_PUBLISH_IN_PROGRESS,
    TV_LIVE_STREAM_PUBLISH_SUCCESS,
    TV_LIVE_STREAM_UN_PUBLISH_ERROR,
    TV_LIVE_STREAM_UN_PUBLISH_IN_PROGRESS,
    TV_LIVE_STREAM_UN_PUBLISH_SUCCESS,
    TV_LIVE_STREAM_UPDATE_ERROR,
    TV_LIVE_STREAM_UPDATE_IN_PROGRESS,
    TV_LIVE_STREAM_UPDATE_SUCCESS,
    TV_LIVE_STREAM_URL_FETCH_ERROR,
    TV_LIVE_STREAM_URL_FETCH_IN_PROGRESS,
    TV_LIVE_STREAM_URL_FETCH_SUCCESS,
    TV_LIVE_STREAMS_FETCH_ERROR,
    TV_LIVE_STREAMS_FETCH_IN_PROGRESS,
    TV_LIVE_STREAMS_FETCH_SUCCESS,
    UPDATE_DESTINATIONS_FETCH_ERROR,
    UPDATE_DESTINATIONS_FETCH_IN_PROGRESS,
    UPDATE_DESTINATIONS_FETCH_SUCCESS,
    YOUTUBE_REFRESH_ACCESS_TOKEN_ERROR,
    YOUTUBE_REFRESH_ACCESS_TOKEN_IN_PROGRESS,
    YOUTUBE_REFRESH_ACCESS_TOKEN_SUCCESS,
    YOUTUBE_SETTINGS_TAB_SET,
} from '../../constants/mediaNodes/tv';
import {
    urladdTvLiveStream,
    urlDeleteDestination,
    urlFetchBroadcastList,
    urlFetchGoLive,
    urlFetchLiveVideosList,
    urlFetchTvLiveStream,
    urlFetchTvLiveStreams,
    urlfetchTvLiveStreamUrl,
    urlFetchYoutubeStatus,
    urlpublishTvLiveStream,
    urlRemoveMediaNode,
    urlSyncStudioLiveStream,
    urlUnpublishTvLiveStream,
    urlUpdateDestinations,
    urlYoutubeRefreshAccessToken,
} from '../../constants/mediaNodes/url';
import { handleErrorMessage } from '../../utils/errorMessages';
import Axios from 'axios';

const fetchTvLiveStreamsInProgress = () => {
    return {
        type: TV_LIVE_STREAMS_FETCH_IN_PROGRESS,
    };
};

const fetchTvLiveStreamsSuccess = (value, skip, limit, total) => {
    return {
        type: TV_LIVE_STREAMS_FETCH_SUCCESS,
        value,
        skip,
        limit,
        total,
    };
};

const fetchTvLiveStreamsError = (message) => {
    return {
        type: TV_LIVE_STREAMS_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchTvLiveStreams = (skip, limit, cb) => (dispatch) => {
    dispatch(fetchTvLiveStreamsInProgress());

    const URL = urlFetchTvLiveStreams(skip, limit);
    Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchTvLiveStreamsSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchTvLiveStreamsError(message));
            if (cb) {
                cb(null);
            }
        });
};

const fetchTvLiveStreamInProgress = () => {
    return {
        type: TV_LIVE_STREAM_FETCH_IN_PROGRESS,
    };
};

const fetchTvLiveStreamSuccess = (value) => {
    return {
        type: TV_LIVE_STREAM_FETCH_SUCCESS,
        value,
    };
};

const fetchTvLiveStreamError = (message) => {
    return {
        type: TV_LIVE_STREAM_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchTvLiveStream = (id, cb) => (dispatch) => {
    dispatch(fetchTvLiveStreamInProgress());

    const URL = urlFetchTvLiveStream(id);
    Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchTvLiveStreamSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchTvLiveStreamError(message));
            if (cb) {
                cb(null);
            }
        });
};

const addTvLiveStreamInProgress = () => {
    return {
        type: TV_LIVE_STREAM_ADD_IN_PROGRESS,
    };
};

const addTvLiveStreamSuccess = (value, message) => {
    return {
        type: TV_LIVE_STREAM_ADD_SUCCESS,
        value,
        message,
        variant: 'success',
    };
};

const addTvLiveStreamError = (message) => {
    return {
        type: TV_LIVE_STREAM_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const addTvLiveStream = (data, cb) => (dispatch) => {
    dispatch(addTvLiveStreamInProgress());

    const URL = urladdTvLiveStream();
    Axios.post(URL, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(addTvLiveStreamSuccess(res.data && res.data.result, 'Live Stream Data Added Successfully'));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(addTvLiveStreamError(message));
            if (cb) {
                cb(null, message);
            }
        });
};

const updateTvLiveStreamInProgress = () => {
    return {
        type: TV_LIVE_STREAM_UPDATE_IN_PROGRESS,
    };
};

const updateTvLiveStreamSuccess = (value, message) => {
    return {
        type: TV_LIVE_STREAM_UPDATE_SUCCESS,
        value,
        message,
        variant: 'success',
    };
};

const updateTvLiveStreamError = (message) => {
    return {
        type: TV_LIVE_STREAM_UPDATE_ERROR,
        message,
        variant: 'error',
    };
};

export const updateTvLiveStream = (id, data, cb) => (dispatch) => {
    dispatch(updateTvLiveStreamInProgress());

    const URL = urlFetchTvLiveStream(id);
    Axios.put(URL, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(updateTvLiveStreamSuccess(res.data && res.data.result, 'Live Stream Data Updated Successfully'));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(updateTvLiveStreamError(message));
            if (cb) {
                cb(null);
            }
        });
};

const deleteTvLiveStreamInProgress = () => {
    return {
        type: TV_LIVE_STREAM_DELETE_IN_PROGRESS,
    };
};

const deleteTvLiveStreamSuccess = (value, message) => {
    return {
        type: TV_LIVE_STREAM_DELETE_SUCCESS,
        value,
        message,
        variant: 'success',
    };
};

const deleteTvLiveStreamError = (message) => {
    return {
        type: TV_LIVE_STREAM_DELETE_ERROR,
        message,
    };
};

export const deleteTvLiveStream = (id, cb) => (dispatch) => {
    dispatch(deleteTvLiveStreamInProgress());

    const URL = urlFetchTvLiveStream(id);
    Axios.delete(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(deleteTvLiveStreamSuccess(res.data, 'TV Live Stream Deleted Successfully'));
            if (cb) {
                cb(res.data);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(deleteTvLiveStreamError(message));
            if (cb) {
                cb(null);
            }
        });
};

const fetchTvLiveStreamUrlInProgress = () => {
    return {
        type: TV_LIVE_STREAM_URL_FETCH_IN_PROGRESS,
    };
};

export const fetchTvLiveStreamUrlSuccess = (value) => {
    return {
        type: TV_LIVE_STREAM_URL_FETCH_SUCCESS,
        value,
    };
};

const fetchTvLiveStreamUrlError = (message) => {
    return {
        type: TV_LIVE_STREAM_URL_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchTvLiveStreamUrl = (id, cb) => (dispatch) => {
    dispatch(fetchTvLiveStreamUrlInProgress());

    const URL = urlfetchTvLiveStreamUrl(id);
    Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchTvLiveStreamUrlSuccess(res.data && res.data.result && res.data.result));
            if (cb) {
                cb(res.data && res.data.result && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchTvLiveStreamUrlError(message));
            if (cb) {
                cb(null);
            }
        });
};

const publishTvLiveStreamInProgress = () => {
    return {
        type: TV_LIVE_STREAM_PUBLISH_IN_PROGRESS,
    };
};

const publishTvLiveStreamSuccess = (value) => {
    return {
        type: TV_LIVE_STREAM_PUBLISH_SUCCESS,
        value,
    };
};

const publishTvLiveStreamError = (message) => {
    return {
        type: TV_LIVE_STREAM_PUBLISH_ERROR,
        message,
        variant: 'error',
    };
};

export const publishTvLiveStream = (id, cb) => (dispatch) => {
    dispatch(publishTvLiveStreamInProgress());

    const URL = urlpublishTvLiveStream(id);
    Axios.put(URL, {}, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(publishTvLiveStreamSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(publishTvLiveStreamError(message));
            if (cb) {
                cb(null);
            }
        });
};

const unpublishTvLiveStreamInProgress = () => {
    return {
        type: TV_LIVE_STREAM_UN_PUBLISH_IN_PROGRESS,
    };
};

const unpublishTvLiveStreamSuccess = (value) => {
    return {
        type: TV_LIVE_STREAM_UN_PUBLISH_SUCCESS,
        value,
    };
};

const unpublishTvLiveStreamError = (message) => {
    return {
        type: TV_LIVE_STREAM_UN_PUBLISH_ERROR,
        message,
        variant: 'error',
    };
};

export const unpublishTvLiveStream = (id, cb) => (dispatch) => {
    dispatch(unpublishTvLiveStreamInProgress());

    const URL = urlUnpublishTvLiveStream(id);
    Axios.put(URL, {}, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(unpublishTvLiveStreamSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(unpublishTvLiveStreamError(message));
            if (cb) {
                cb(null);
            }
        });
};

// Setup Live stream
export const showLiveStreamSetupDialog = () => {
    return {
        type: LIVE_STREAM_SETUP_DIALOG_SHOW,
    };
};

export const hideLiveStreamSetupDialog = () => {
    return {
        type: LIVE_STREAM_SETUP_DIALOG_HIDE,
    };
};

export const showLiveStreamDeleteDialog = (value) => {
    return {
        type: SHOW_LIVE_STREAM_DELETE_DIALOG,
        value,
    };
};

export const hideLiveStreamDeleteDialog = () => {
    return {
        type: HIDE_LIVE_STREAM_DELETE_DIALOG,
    };
};

export const setLiveStreamSetupName = (value, valid) => {
    return {
        type: LIVE_STREAM_SETUP_NAME_SET,
        value,
        valid,
    };
};

export const setLiveStreamSetupNode = (value) => {
    return {
        type: LIVE_STREAM_SETUP_NODE_SET,
        value,
    };
};

export const setLiveStreamVisibility = (value) => {
    return {
        type: LIVE_STREAM_VISIBILITY_SET,
        value,
    };
};

export const setLiveStreamId = (value) => {
    return {
        type: LIVE_STREAM_ID_SET,
        value,
    };
};

export const setLiveStreamKey = (value) => {
    return {
        type: LIVE_STREAM_KEY_SET,
        value,
    };
};

export const setLiveStreamThumbnail = (value) => {
    return {
        type: LIVE_STREAM_THUMBNAIL_SET,
        value,
    };
};

export const setLiveStreamDescription = (value, valid) => {
    return {
        type: LIVE_STREAM_DESCRIPTION_SET,
        value,
        valid,
    };
};

export const setLiveStreamScheduleStartDate = (value, valid) => {
    return {
        type: LIVE_STREAM_SCHEDULE_START_DATE_SET,
        value,
        valid,
    };
};

export const setLiveStreamScheduleEndDate = (value, valid) => {
    return {
        type: LIVE_STREAM_SCHEDULE_END_DATE_SET,
        value,
        valid,
    };
};

const fetchLiveVideosListInProgress = () => {
    return {
        type: LIVE_VIDEOS_LIST_FETCH_IN_PROGRESS,
    };
};

const fetchLiveVideosListSuccess = (value, skip, limit, total) => {
    return {
        type: LIVE_VIDEOS_LIST_FETCH_SUCCESS,
        value,
        skip,
        limit,
        total,
    };
};

const fetchLiveVideosListError = (message) => {
    return {
        type: LIVE_VIDEOS_LIST_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchLiveVideosList = (skip, limit, cb) => (dispatch) => {
    dispatch(fetchLiveVideosListInProgress());

    const URL = urlFetchLiveVideosList(skip, limit);
    Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchLiveVideosListSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchLiveVideosListError(message));
            if (cb) {
                cb(null);
            }
        });
};

const fetchBroadcastListInProgress = () => {
    return {
        type: BROADCAST_LIST_FETCH_IN_PROGRESS,
    };
};

const fetchBroadcastListSuccess = (value, skip, limit, total) => {
    return {
        type: BROADCAST_LIST_FETCH_SUCCESS,
        value,
        skip,
        limit,
        total,
    };
};

const fetchBroadcastListError = (message) => {
    return {
        type: BROADCAST_LIST_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchBroadcastList = (skip, limit, cb) => (dispatch) => {
    dispatch(fetchBroadcastListInProgress());

    const URL = urlFetchBroadcastList(skip, limit);
    Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchBroadcastListSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchBroadcastListError(message));
            if (cb) {
                cb(null);
            }
        });
};
export const setScheduleLiveSwitch = (value) => {
    return {
        type: SCHEDULE_LIVE_SWITCH_SET,
        value,
    };
};

export const setYoutubeSettingsTab = (value) => {
    return {
        type: YOUTUBE_SETTINGS_TAB_SET,
        value,
    };
};

export const setSelectedDestinations = (value) => {
    return {
        type: SELECTED_DESTINATIONS_LIST_SET,
        value,
    };
};

// Remove MediaNode
export const showRemoveMediaNodeConfirmDialog = (value) => {
    return {
        type: REMOVE_MEDIANODE_CONFIRM_DIALOG_SHOW,
        value,
    };
};

export const hideRemoveMediaNodeConfirmDialog = () => {
    return {
        type: REMOVE_MEDIANODE_CONFIRM_DIALOG_HIDE,
    };
};

const fetchRemoveMediaNodeInProgress = () => {
    return {
        type: REMOVE_MEDIA_NODE_FETCH_IN_PROGRESS,
    };
};

const fetchRemoveMediaNodeSuccess = (value) => {
    return {
        type: REMOVE_MEDIA_NODE_FETCH_SUCCESS,
        value,
    };
};

const fetchRemoveMediaNodeError = (message) => {
    return {
        type: REMOVE_MEDIA_NODE_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchRemoveMediaNode = (id, cb) => (dispatch) => {
    dispatch(fetchRemoveMediaNodeInProgress());

    const URL = urlRemoveMediaNode(id);
    Axios.put(URL, '', {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchRemoveMediaNodeSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchRemoveMediaNodeError(message));
            if (cb) {
                cb(null, message);
            }
        });
};

// Update Destinations
const fetchUpdateDestinationsInProgress = () => {
    return {
        type: UPDATE_DESTINATIONS_FETCH_IN_PROGRESS,
    };
};

const fetchUpdateDestinationsSuccess = (value) => {
    return {
        type: UPDATE_DESTINATIONS_FETCH_SUCCESS,
        value,
    };
};

const fetchUpdateDestinationsError = (message) => {
    return {
        type: UPDATE_DESTINATIONS_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchUpdateDestinations = (id, data, cb) => (dispatch) => {
    dispatch(fetchUpdateDestinationsInProgress());

    const URL = urlUpdateDestinations(id);
    Axios.put(URL, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchUpdateDestinationsSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchUpdateDestinationsError(message));
            if (cb) {
                cb(null, message);
            }
        });
};

// Delete Destination
const fetchDeleteDestinationInProgress = () => {
    return {
        type: DELETE_DESTINATION_FETCH_IN_PROGRESS,
    };
};

const fetchDeleteDestinationSuccess = (value) => {
    return {
        type: DELETE_DESTINATION_FETCH_SUCCESS,
        value,
    };
};

const fetchDeleteDestinationError = (message) => {
    return {
        type: DELETE_DESTINATION_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchDeleteDestination = (liveStreamID, destinationID, cb) => (dispatch) => {
    dispatch(fetchDeleteDestinationInProgress());

    const URL = urlDeleteDestination(liveStreamID, destinationID);
    Axios.delete(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchDeleteDestinationSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchDeleteDestinationError(message));
            if (cb) {
                cb(null, message);
            }
        });
};

// Sync Studio Live Stream
const fetchSyncStudioLiveStreamInProgress = () => {
    return {
        type: SYNC_STUDIO_LIVE_STREAM_FETCH_IN_PROGRESS,
    };
};

const fetchSyncStudioLiveStreamSuccess = (value) => {
    return {
        type: SYNC_STUDIO_LIVE_STREAM_FETCH_SUCCESS,
        value,
    };
};

const fetchSyncStudioLiveStreamError = (message) => {
    return {
        type: SYNC_STUDIO_LIVE_STREAM_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchSyncStudioLiveStream = (url, id, nodeID, cb) => (dispatch) => {
    dispatch(fetchSyncStudioLiveStreamInProgress());

    const URL = urlSyncStudioLiveStream(url, id);
    Axios.put(URL, '', {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(fetchSyncStudioLiveStreamSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchSyncStudioLiveStreamError(message));
            if (cb) {
                cb(null, message);
            }
        });
};

const fetchYoutubeRefreshAccessTokenInProgress = () => {
    return {
        type: YOUTUBE_REFRESH_ACCESS_TOKEN_IN_PROGRESS,
    };
};

const fetchYoutubeRefreshAccessTokenSuccess = (value) => {
    return {
        type: YOUTUBE_REFRESH_ACCESS_TOKEN_SUCCESS,
        value,
    };
};

const fetchYoutubeRefreshAccessTokenError = (message) => {
    return {
        type: YOUTUBE_REFRESH_ACCESS_TOKEN_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchYoutubeRefreshAccessToken = (channelId, cb) => (dispatch) => {
    dispatch(fetchYoutubeRefreshAccessTokenInProgress());

    const URL = urlYoutubeRefreshAccessToken(channelId);
    Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchYoutubeRefreshAccessTokenSuccess(res.data));
            if (cb) {
                cb(res.data);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchYoutubeRefreshAccessTokenError(message));
            if (cb) {
                cb(null, message);
            }
        });
};

export const setStreamInfoEmpty = (value) => {
    return {
        type: SET_STREAM_INFO_EMPTY,
        value,
    };
};

// Go Live
const fetchGoLiveInProgress = () => {
    return {
        type: GO_LIVE_FETCH_IN_PROGRESS,
    };
};

const fetchGoLiveSuccess = (value) => {
    return {
        type: GO_LIVE_FETCH_SUCCESS,
        value,
    };
};

const fetchGoLiveError = (message) => {
    return {
        type: GO_LIVE_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchGoLive = (id, cb) => (dispatch) => {
    dispatch(fetchGoLiveInProgress());

    const URL = urlFetchGoLive(id);
    Axios.post(URL, '', {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchGoLiveSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchGoLiveError(message));
            if (cb) {
                cb(null);
            }
        });
};

const fetchYoutubeStatusInProgress = () => {
    return {
        type: FETCH_YOUTUBE_STATUS_IN_PROGRESS,
    };
};

const fetchYoutubeStatusSuccess = (value) => {
    return {
        type: FETCH_YOUTUBE_STATUS_SUCCESS,
        value,
    };
};

const fetchYoutubeStatusError = (message) => {
    return {
        type: FETCH_YOUTUBE_STATUS_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchYoutubeStatus = (id, cb) => (dispatch) => {
    dispatch(fetchYoutubeStatusInProgress());

    const URL = urlFetchYoutubeStatus(id);
    Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchYoutubeStatusSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchYoutubeStatusError(message));
            if (cb) {
                cb(null);
            }
        });
};
